import { TierKey } from "../redux/allocationService";
import { StatusStyle } from "../redux/cartSlice";
import { DeliveryZonePoint } from "../redux/deliverySlice";
import { Menu } from "../views/Menus/MenuList/MenusTable";

export const dateTFormat = (date: Date) => {
  function formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const paddedMonth = month.toString().padStart(2, "0");
    const paddedDay = day.toString().padStart(2, "0");
    const paddedHours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    const paddedSeconds = seconds.toString().padStart(2, "0");

    return `${year}-${paddedMonth}-${paddedDay}T${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
  }
  return formatDate(date);
};

export const formatTime = (dateString: string): string => {
  const date = new Date(dateString);
  const hour = date.getHours();
  const minute = date.getMinutes();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const formattedMinute =
    minute < 10 ? `0${minute}` : minute.toString().padStart(2, "0");
  return `${hour}:${minute}hrs`;
};

export function capitalizeFirstLetter(string: string): string {
  if (!string) return string;
  return string
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export const categoryTagsOptionsFunction = (data: any) => {
  if (data && data.categoryList && data.categoryList.categories) {
    const categoryArray = data.categoryList.categories;
    return categoryArray.map((item: any) => {
      return {
        value: capitalizeFirstLetter(item.display),
        label: capitalizeFirstLetter(item.display),
      };
    });
  } else {
    console.error("Invalid data structure:", data);
    return [];
  }
};

export const capitalizeFirstLetterEdit = (string: string) => {
  if (!string) return ""; // Handle undefined/null/empty string
  return string
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

// Modified categoryTagsOptionsFunction to capitalize the first letter
export const categoryTagsOptionsFunctionEdit = (data: any) => {
  if (data && data.categoryList && data.categoryList.categories) {
    const categoryArray = data.categoryList.categories;

    const categoryTagsOptions = categoryArray
      .filter((item: any) => {
        const hasDisplay = item && item.display;
        if (!hasDisplay) {
          // console.warn("⚠️ Category item missing display property:", item);
        }
        return hasDisplay;
      })
      .map((item: any) => {
        const capitalizedDisplay = capitalizeFirstLetterEdit(item.display);
        return { value: capitalizedDisplay, label: capitalizedDisplay };
      });
    return categoryTagsOptions;
  } else {
    console.error("Invalid data structure:", data);
    return [];
  }
};

//Resaturant Open Status Managment
export const isRestaurantOpen = (
  openingTime: string,
  closingTime: string,
): boolean => {
  const currentTime = new Date();
  const currentHours = currentTime.getHours();
  const currentMinutes = currentTime.getMinutes();
  const currentTimeString = `${currentHours
    .toString()
    .padStart(2, "0")}:${currentMinutes.toString().padStart(2, "0")}`;

  return currentTimeString >= openingTime && currentTimeString <= closingTime;
};

export const customFilterOption = (option: any, inputValue: any) => {
  const query = String(inputValue || "").toLowerCase().trim();
  if (!query) return true;

  const searchText = String(
    option?.data?.displayName || option?.data?.label || option?.label || ""
  ).toLowerCase();

  // Match all typed words in any order, same behavior as the text-input search.
  const words = query.split(/\s+/).filter(Boolean);
  return words.every((word) => searchText.includes(word));
};

export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + "...";
};

export const formatTimestamp = (timestamp?: { _seconds: number }): string => {
  if (!timestamp) {
    return "N/A";
  }
  const date = new Date(timestamp._seconds * 1000);
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
};

//Inventory Id
export const InventoryId = (date: any) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}${month}${day}`;
};

export const formatTime12hrs = (time: string) => {
  const [hours, minutes] = time.split(":").map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  const adjustedHours = hours % 12 || 12;
  return `${adjustedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
};

export const extractImageFilename = (
  fullUrl: string,
  RestID: string,
): string => {
  const basePath = `https://storage.googleapis.com/fooddelivery-7eac6.appspot.com/Restaurants/${RestID}/MenuItems/`;
  return fullUrl.replace(basePath, "");
};

// src/utils/availabilityUtils.ts

export const dayNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const getCurrentDayIndex = (): number => {
  return new Date().getDay(); // Returns 0-6 (Sun-Sat)
};

export const isItemAvailableToday = (availableDays?: number[]): boolean => {
  if (!availableDays || availableDays.length === 0) return true;
  const today = getCurrentDayIndex();
  return availableDays.includes(today);
};

export const getAvailableDayNames = (availableDays?: number[]): string => {
  if (!availableDays || availableDays.length === 0) return "No Available days";
  return availableDays.map((day) => dayNames[day]).join(", ");
};

export const getCurrentDayName = (): string => {
  return dayNames[getCurrentDayIndex()];
};

// Add this utility function outside your component
export const sortMenusByAvailability = (menus: Menu[]) => {
  return [...menus]
    .filter((menu) => menu.isAvailable)
    .sort((a, b) => {
      const isAvailableNow = (menu: Menu) => {
        const [startTimeStr, endTimeStr] = menu.servingTime?.split("-") || [];
        if (!startTimeStr || !endTimeStr) return true;
        const now = new Date();
        const startTime = new Date();
        const endTime = new Date();

        const [startHours, startMinutes] = startTimeStr.split(":").map(Number);
        const [endHours, endMinutes] = endTimeStr.split(":").map(Number);

        startTime.setHours(startHours, startMinutes, 0, 0);
        endTime.setHours(endHours, endMinutes, 0, 0);

        return now >= startTime && now <= endTime;
      };

      const aAvailable = isAvailableNow(a);
      const bAvailable = isAvailableNow(b);

      if (aAvailable && !bAvailable) return -1;
      if (!aAvailable && bAvailable) return 1;
      return 0;
    });
};
export const isItemAvailableOnDate = (
  availableDays?: number[],
  targetDate?: Date,
): boolean => {
  if (!availableDays || availableDays.length === 0 || !targetDate) return true;
  const dayIndex = targetDate.getDay(); // 0-6
  return availableDays.includes(dayIndex);
};

export const generateTimeSlots = (
  servingTime: string,
): { label: string; value: string }[] => {
  const [startStr, endStr] = servingTime.split("-");
  const [startHour, startMin] = startStr.split(":").map(Number);
  const [endHour, endMin] = endStr.split(":").map(Number);

  const slots: { label: string; value: string }[] = [];

  let current = new Date();
  current.setHours(startHour, startMin, 0, 0);

  const end = new Date();
  end.setHours(endHour, endMin, 0, 0);

  while (current < end) {
    const next = new Date(current.getTime() + 60 * 60 * 1000);

    if (next > end) break;

    const format = (date: Date) =>
      `${date.getHours().toString().padStart(2, "0")}:${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;

    const slot = `${format(current)} - ${format(next)}`;

    slots.push({ label: slot, value: slot });

    current = next;
  }

  return slots;
};

export const getLocalDateString = (date = new Date()) => {
  const offsetDate = new Date(
    date.getTime() - date.getTimezoneOffset() * 60000,
  );
  return offsetDate.toISOString().split("T")[0];
};

export const isPointInPolygon = (
  point: DeliveryZonePoint,
  polygon: DeliveryZonePoint[],
): boolean => {
  if (polygon.length < 3) return false;

  let intersections = 0;
  let j = polygon.length - 1;

  for (let i = 0; i < polygon.length; i++) {
    const vertex1 = polygon[i];
    const vertex2 = polygon[j];

    if (
      // eslint-disable-next-line no-mixed-operators
      vertex1.longitude > point.latitude !==
      // eslint-disable-next-line no-mixed-operators
      vertex2.latitude > point.latitude
    ) {
      const xIntersection =
        ((vertex2.longitude - vertex1.longitude) *
          (point.latitude - vertex1.latitude)) /
          (vertex2.latitude - vertex1.latitude) +
        vertex1.longitude;

      if (point.longitude < xIntersection) {
        intersections++;
      }
    }
    j = i;
  }

  return intersections % 2 === 1;
};

const API_BASE_COMPRESS_IMAGE_URL =
  process.env.REACT_APP_COMPRESS_IMAGE_URL ||
  "https://storage.googleapis.com/fooddelivery-7eac6.appspot.com";

export const getCompressedImageUrl = (
  originalUrl: string,
  thumbnailSize: number = 256,
): string => {
  if (!originalUrl) return "";

  try {
    // Check if it's already a compressed URL
    if (originalUrl.includes("thumb@")) {
      return originalUrl;
    }

    // Parse the original URL to extract components
    const url = new URL(originalUrl);
    const pathSegments = url.pathname
      .split("/")
      .filter((segment) => segment.length > 0);

    // We need at least 3 segments: pathType/resourceId/subPath/filename
    if (pathSegments.length < 3) {
      return originalUrl; // Not enough path segments
    }

    // Extract the filename (last segment)
    const fileName = pathSegments[pathSegments.length - 1];

    // Extract file name without extension
    const fileNameWithoutExtension = fileName.split(".")[0];

    // Get all path segments except the filename
    const pathWithoutFilename = pathSegments.slice(1, -1).join("/");

    // Construct the compressed URL:
    // Base URL + path structure + modified filename
    const compressedUrl = `${API_BASE_COMPRESS_IMAGE_URL}/${pathWithoutFilename}/thumb@${thumbnailSize}_${fileNameWithoutExtension}.webp`;

    return compressedUrl;
  } catch (error) {
    console.warn("Failed to convert image URL:", error);
    return originalUrl; // Fallback to original URL
  }
};

/**
 * Get image URL with fallback options
 * @param originalUrl - The original image URL
 * @param defaultImage - Default/fallback image
 * @param thumbnailSize - Thumbnail size for compression
 * @returns Image URL with fallbacks
 */
export const getImageUrlWithFallback = (
  originalUrl: string,
  defaultImage: string,
  thumbnailSize: number = 256,
): string => {
  if (!originalUrl) return defaultImage;

  return getCompressedImageUrl(originalUrl, thumbnailSize);
};

// utility/Utility.ts
export const formatFirestoreTimestamp = (timestamp: any): string => {
  if (!timestamp) {
    const now = new Date();
    return (
      now.toLocaleDateString("en-GB") +
      ", " +
      now.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
    );
  }

  try {
    let date: Date;

    if (timestamp.seconds) {
      date = new Date(timestamp.seconds * 1000);
    } else {
      date = new Date(timestamp);
    }

    // Format: 24/09/2025, 11:10 am
    const formattedDate = date.toLocaleDateString("en-GB");
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return `${formattedDate}, ${formattedTime}`;
  } catch (error) {
    console.error("Error formatting timestamp:", error);
    const now = new Date();
    return (
      now.toLocaleDateString("en-GB") +
      ", " +
      now.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
    );
  }
};
export const normalizePhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return "";

  // Remove all non-digit characters
  const digitsOnly = phoneNumber.replace(/\D/g, "");

  // Handle different formats
  if (digitsOnly.startsWith("94")) {
    // Remove country code (+94) and return 10-digit local number
    const localNumber = digitsOnly.substring(2);
    return localNumber.length === 9 ? "0" + localNumber : localNumber;
  } else if (digitsOnly.startsWith("0")) {
    // Already in correct format
    return digitsOnly;
  } else if (digitsOnly.length === 9) {
    // Missing leading zero
    return "0" + digitsOnly;
  }

  return digitsOnly;
};

export const validateSriLankanPhoneNumber = (
  phoneNumber: string,
): { isValid: boolean; message?: string } => {
  if (!phoneNumber || phoneNumber.trim() === "") {
    return { isValid: false, message: "Phone number is required" };
  }

  const normalized = normalizePhoneNumber(phoneNumber);

  // Check if it's exactly 10 digits after normalization
  if (!/^\d{10}$/.test(normalized)) {
    return {
      isValid: false,
      message: "Please enter a valid 10-digit phone number",
    };
  }

  // Check if it starts with valid Sri Lankan mobile prefixes
  const validPrefixes = [
    "070",
    "071",
    "072",
    "074",
    "075",
    "076",
    "077",
    "078",
    "079",
    "011",
  ];
  const prefix = normalized.substring(0, 3);

  if (!validPrefixes.includes(prefix)) {
    return {
      isValid: false,
      message: "Please enter a valid Sri Lankan mobile number (07xx xxx xxx)",
    };
  }

  return { isValid: true };
};

export const isDateInPast = (dateString: string): boolean => {
  const selectedDate = new Date(dateString);
  const today = new Date();

  const selectedDateStart = new Date(
    selectedDate.getFullYear(),
    selectedDate.getMonth(),
    selectedDate.getDate(),
  );

  const todayStart = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );

  return selectedDateStart < todayStart;
};

export function formatTimeZone(dateInput: any): string {
  if (!dateInput) return "N/A";

  try {
    // Handle Firestore Timestamp
    if (dateInput?.toDate) {
      const date = dateInput.toDate();
      return date.toLocaleString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    }

    // Handle Date object
    if (dateInput instanceof Date) {
      return dateInput.toLocaleString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    }

    // Handle timestamp with seconds
    if (dateInput?.seconds) {
      const date = new Date(dateInput.seconds * 1000);
      return date.toLocaleString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    }

    // Handle string
    if (typeof dateInput === "string") {
      // Check if it's in the format "February 17, 2026 at 11:38:29 AM UTC+5:30"
      const match = dateInput.match(/at (.+) UTC/);
      if (match) {
        return match[1].trim();
      }
      // Try to parse as date
      const date = new Date(dateInput);
      if (!isNaN(date.getTime())) {
        return date.toLocaleString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });
      }
      return dateInput;
    }

    // Handle number
    if (typeof dateInput === "number") {
      const date = new Date(dateInput);
      return date.toLocaleString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    }
  } catch (error) {
    console.error("Error formatting time:", error);
  }

  return String(dateInput);
}

export function formatDate(dateInput: any): string {
  if (!dateInput) return "N/A";

  try {
    // Handle Firestore Timestamp
    if (dateInput?.toDate) {
      const date = dateInput.toDate();
      return date
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "/");
    }

    // Handle Date object
    if (dateInput instanceof Date) {
      return dateInput
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "/");
    }

    // Handle timestamp with seconds (Firestore old format)
    if (dateInput?.seconds) {
      const date = new Date(dateInput.seconds * 1000);
      return date
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "/");
    }

    // Handle string
    if (typeof dateInput === "string") {
      // Check if it's in the format "February 17, 2026 at 11:38:29 AM UTC+5:30"
      if (dateInput.includes(" at ")) {
        return dateInput.split(" at ")[0];
      }
      // Try to parse as date
      const date = new Date(dateInput);
      if (!isNaN(date.getTime())) {
        return date
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
          .replace(/\//g, "/");
      }
      return dateInput;
    }

    // Handle number (timestamp)
    if (typeof dateInput === "number") {
      const date = new Date(dateInput);
      return date
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "/");
    }
  } catch (error) {
    console.error("Error formatting date:", error);
  }

  return String(dateInput);
}

export function formatFullTimestamp(dateInput: any): string {
  if (!dateInput) return "N/A";

  try {
    // Handle Firestore Timestamp
    if (dateInput?.toDate) {
      const date = dateInput.toDate();
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    }

    // Handle Date object
    if (dateInput instanceof Date) {
      return dateInput.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    }

    // Handle timestamp with seconds
    if (dateInput?.seconds) {
      const date = new Date(dateInput.seconds * 1000);
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    }

    // Handle string
    if (typeof dateInput === "string") {
      const date = new Date(dateInput);
      if (!isNaN(date.getTime())) {
        return date.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });
      }
      return dateInput;
    }
  } catch (error) {
    console.error("Error formatting full timestamp:", error);
  }

  return String(dateInput);
}

export function calcDuration(start: string, end: string): string {
  const parseTime = (timeStr: string): number => {
    const match = timeStr.match(/(\d+):(\d+):(\d+) (AM|PM)/);
    if (!match) return 0;

    let hours = parseInt(match[1]);
    const minutes = parseInt(match[2]);
    const period = match[4];

    if (period === "PM" && hours !== 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;

    return hours * 60 + minutes;
  };

  const startMinutes = parseTime(formatTime(start));
  const endMinutes = parseTime(formatTime(end));

  return `${Math.abs(endMinutes - startMinutes)} min`;
}

export function statusStyle(status?: string): StatusStyle {
  if (!status) return { bg: "#f1f5f9", text: "#64748b", border: "#cbd5e1" };

  const statusLower = status.toLowerCase();
  if (statusLower.includes("delivered") || statusLower.includes("arrived")) {
    return { bg: "#f0fdf4", text: "#16a34a", border: "#86efac" };
  }
  if (statusLower.includes("active") || statusLower.includes("pending")) {
    return { bg: "#fffbeb", text: "#d97706", border: "#fcd34d" };
  }
  return { bg: "#f8fafc", text: "#64748b", border: "#e2e8f0" };
}


export function getTierFromTags(tags?: { brand?: string[]; class?: string[]; [key: string]: any }): TierKey {
  if (!tags?.class || tags.class.length === 0) return "none";
  const cls = tags.class[0]?.toLowerCase() ?? "";
  if (cls === "platinum") return "platinum";
  if (cls === "gold") return "gold";
  if (cls === "bronze") return "bronze";
  if (cls === "value") return "value";
  if (cls === "staff") return "staff";
  if (cls === "rasabath") return "rasabath";
  if (cls === "wf-gold") return "wf-gold";
  if (cls === "wf-bronze") return "wf-bronze";
  return "none";
}

export const TIER_LABELS: Record<TierKey, string> = {
  platinum: "Platinum",
  gold: "Gold",
  bronze: "Bronze",
  value: "Value",
  staff: "Staff",
  rasabath: "Rasabath",
  "wf-gold": "WF-Gold",
  "wf-bronze": "WF-Bronze",
  none: "No Tier",
};